/* ------------------------------------------------------------------------------------------------
   MEMO CUSTOM — Comportements des sections « bon Journey Book » (xm-dk-*)
   1. apparitions au défilement (une seule fois, jamais bloquantes)
   2. ancres avec compensation de l'en-tête collant
   3. barre d'action collante mobile (apparaît après le bandeau d'ouverture, s'efface sur l'appel final)
   Chargé une seule fois : le script est idempotent et s'auto-relance à chaque section rendue
   (utile dans l'éditeur de thème, où une section peut être remplacée seule).
   ------------------------------------------------------------------------------------------------ */
window.xmDk = (function () {
  var revealObserver = null;

  function getObserver() {
    if (revealObserver || !('IntersectionObserver' in window)) return revealObserver;
    revealObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          revealObserver.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.06 }
    );
    return revealObserver;
  }

  function reveal(root) {
    var targets = root.querySelectorAll(
      '[data-dk-reveal]:not(.is-in), [data-dk-zoom]:not(.is-in), [data-dk-curtain]:not(.is-in), .dk-words:not(.is-in), .dk-rule--draw:not(.is-in), .dk-mark:not(.is-in)'
    );
    var observer = getObserver();
    var vh = window.innerHeight || 0;

    targets.forEach(function (el) {
      /* Déjà à l'écran au chargement : on joue tout de suite, sans attendre l'observateur.
         Le contenu au-dessus de la ligne de flottaison ne dépend donc jamais d'un défilement. */
      var rect = el.getBoundingClientRect();
      if (rect.top < vh * 0.92 && rect.bottom > 0) {
        el.classList.add('is-in');
        return;
      }
      if (observer) {
        observer.observe(el);
      } else {
        el.classList.add('is-in');
      }
    });
  }

  function anchors(root) {
    root.querySelectorAll('a[href^="#"]:not([data-dk-bound])').forEach(function (link) {
      link.setAttribute('data-dk-bound', '');
      link.addEventListener('click', function (event) {
        var id = link.getAttribute('href');
        if (!id || id === '#') return;
        var target = document.querySelector(id);
        if (!target) return;
        event.preventDefault();
        var header = document.querySelector('.header');
        var offset = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({
          top: target.getBoundingClientRect().top + window.pageYOffset - offset - 16,
          behavior: 'smooth'
        });
      });
    });
  }

  function sticky(bar) {
    if (!bar || bar.hasAttribute('data-dk-bound')) return;
    bar.setAttribute('data-dk-bound', '');

    var trigger = document.querySelector('[data-dk-hero]');
    var closer = document.querySelector('[data-dk-final]');

    if (!('IntersectionObserver' in window) || !trigger) {
      bar.classList.add('is-visible');
      return;
    }

    var pastHero = false;
    var atFinal = false;
    var apply = function () {
      bar.classList.toggle('is-visible', pastHero && !atFinal);
    };

    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          pastHero = !e.isIntersecting;
        });
        apply();
      },
      { rootMargin: '-45% 0px 0px 0px' }
    ).observe(trigger);

    if (closer) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            atFinal = e.isIntersecting;
          });
          apply();
        },
        { rootMargin: '0px 0px -20% 0px' }
      ).observe(closer);
    }
  }

  /* compteur : le montant grimpe jusqu'à sa valeur quand il entre à l'écran */
  function counters(root) {
    root.querySelectorAll('[data-dk-count]:not([data-dk-bound])').forEach(function (el) {
      el.setAttribute('data-dk-bound', '');
      var to = parseInt(el.getAttribute('data-dk-count'), 10);
      if (isNaN(to)) return;
      var suffix = el.getAttribute('data-dk-count-suffix') || '';
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduce || !('IntersectionObserver' in window)) {
        el.textContent = to + suffix;
        return;
      }
      el.textContent = '0' + suffix;
      var done = false;
      var settle = function () {
        if (done) return;
        done = true;
        el.textContent = to + suffix;
      };
      /* si rien ne s'est déclenché au bout de 3 s (onglet en arrière-plan, animation gelée),
         on affiche la valeur finale : jamais de « 0€ » affiché durablement. */
      setTimeout(settle, 3000);
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            observer.unobserve(el);
            var start = null;
            var duration = 900;
            var step = function (now) {
              if (done) return;
              if (start === null) start = now;
              var p = Math.min((now - start) / duration, 1);
              var eased = 1 - Math.pow(1 - p, 3);
              el.textContent = Math.round(to * eased) + suffix;
              if (p < 1) {
                requestAnimationFrame(step);
              } else {
                done = true;
              }
            };
            requestAnimationFrame(step);
          });
        },
        { threshold: 0.4 }
      );
      observer.observe(el);
    });
  }

  /* parallaxe légère : le média glisse un peu moins vite que la page */
  function parallax(root) {
    var items = [].slice.call(root.querySelectorAll('[data-dk-parallax]:not([data-dk-bound])'));
    if (!items.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || window.innerWidth < 1000) return;
    items.forEach(function (el) {
      el.setAttribute('data-dk-bound', '');
    });
    if (parallax.running) return;
    parallax.running = true;
    var all = function () {
      return document.querySelectorAll('[data-dk-parallax]');
    };
    var ticking = false;
    var frame = function () {
      ticking = false;
      var vh = window.innerHeight;
      all().forEach(function (el) {
        var rect = el.getBoundingClientRect();
        if (rect.bottom < -200 || rect.top > vh + 200) return;
        var strength = parseFloat(el.getAttribute('data-dk-parallax')) || 0.06;
        var progress = (rect.top + rect.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (progress * strength * -100).toFixed(2) + 'px,0)';
      });
    };
    window.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(frame);
      },
      { passive: true }
    );
    frame();
  }

  /* pastille flottante (ordi) : rappelle le bon dès qu'on a quitté l'ouverture */
  function chip(el) {
    if (!el || el.hasAttribute('data-dk-bound')) return;
    el.setAttribute('data-dk-bound', '');
    var trigger = document.querySelector('[data-dk-hero]');
    var closer = document.querySelector('[data-dk-final]');
    if (!('IntersectionObserver' in window) || !trigger) return;
    var past = false;
    var atEnd = false;
    var apply = function () {
      el.classList.toggle('is-visible', past && !atEnd);
    };
    new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          past = !e.isIntersecting;
        });
        apply();
      },
      { rootMargin: '-45% 0px 0px 0px' }
    ).observe(trigger);
    if (closer) {
      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            atEnd = e.isIntersecting;
          });
          apply();
        },
        { rootMargin: '0px 0px -20% 0px' }
      ).observe(closer);
    }
  }

  /* pastille « −35€ » qui suit le curseur sur une zone marquée data-dk-cursor="texte" */
  function cursorTag(root) {
    var zones = root.querySelectorAll('[data-dk-cursor]:not([data-dk-bound])');
    if (!zones.length) return;
    if (!window.matchMedia('(hover: hover)').matches || window.innerWidth < 1000) return;

    var tag = document.querySelector('.dk-cursor');
    if (!tag) {
      tag = document.createElement('div');
      tag.className = 'dk-cursor';
      document.body.appendChild(tag);
    }

    var x = 0;
    var y = 0;
    var ticking = false;
    var place = function () {
      ticking = false;
      /* left/top, jamais transform : la transformation porte le centrage et l'échelle */
      tag.style.left = x + 'px';
      tag.style.top = y + 'px';
    };

    zones.forEach(function (zone) {
      zone.setAttribute('data-dk-bound', '');
      var label = zone.getAttribute('data-dk-cursor');

      zone.addEventListener('pointerenter', function () {
        tag.textContent = label;
        tag.classList.add('is-on');
      });

      zone.addEventListener('pointerleave', function () {
        tag.classList.remove('is-on');
      });

      zone.addEventListener(
        'pointermove',
        function (event) {
          x = event.clientX;
          y = event.clientY;
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(place);
        },
        { passive: true }
      );
    });
  }

  /* halo jaune qui suit le curseur dans le bandeau d'ouverture */
  function halo(root) {
    root.querySelectorAll('[data-dk-halo]:not([data-dk-bound])').forEach(function (zone) {
      zone.setAttribute('data-dk-bound', '');
      if (!window.matchMedia('(hover: hover)').matches) return;
      var layer = zone.querySelector('.dk-halo');
      if (!layer) return;
      var ticking = false;
      var px = 0;
      var py = 0;
      var move = function () {
        ticking = false;
        layer.style.setProperty('--dk-halo-x', px + '%');
        layer.style.setProperty('--dk-halo-y', py + '%');
      };
      zone.addEventListener(
        'pointermove',
        function (event) {
          var rect = zone.getBoundingClientRect();
          px = (((event.clientX - rect.left) / rect.width) * 100).toFixed(1);
          py = (((event.clientY - rect.top) / rect.height) * 100).toFixed(1);
          layer.classList.add('is-on');
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(move);
        },
        { passive: true }
      );
      zone.addEventListener('pointerleave', function () {
        layer.classList.remove('is-on');
      });
    });
  }

  /* boutons magnétiques (ordi) : 4 px de dérive vers le curseur */
  function magnetic(root) {
    if (!window.matchMedia('(hover: hover)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    root.querySelectorAll('.dk .button:not([data-dk-bound])').forEach(function (btn) {
      btn.setAttribute('data-dk-bound', '');
      btn.addEventListener(
        'pointermove',
        function (event) {
          var rect = btn.getBoundingClientRect();
          var dx = (event.clientX - (rect.left + rect.width / 2)) / rect.width;
          var dy = (event.clientY - (rect.top + rect.height / 2)) / rect.height;
          btn.style.transform = 'translate(' + (dx * 6).toFixed(1) + 'px,' + (dy * 4).toFixed(1) + 'px)';
        },
        { passive: true }
      );
      btn.addEventListener('pointerleave', function () {
        btn.style.transform = '';
      });
    });
  }

  /* cartes parfum : inclinaison très légère vers le curseur */
  function tilt(root) {
    if (!window.matchMedia('(hover: hover)').matches || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.innerWidth < 1000) return;
    root.querySelectorAll('.dk-card:not([data-dk-tilt])').forEach(function (card) {
      card.setAttribute('data-dk-tilt', '');
      card.addEventListener(
        'pointermove',
        function (event) {
          var rect = card.getBoundingClientRect();
          var dx = (event.clientX - (rect.left + rect.width / 2)) / rect.width;
          var dy = (event.clientY - (rect.top + rect.height / 2)) / rect.height;
          card.style.transform =
            'perspective(900px) rotateY(' + (dx * 3).toFixed(2) + 'deg) rotateX(' + (-dy * 2.4).toFixed(2) + 'deg) translateY(-4px)';
        },
        { passive: true }
      );
      card.addEventListener('pointerleave', function () {
        card.style.transform = '';
      });
    });
  }

  /* machine à écrire : allume les caractères un par un, promène un curseur, puis s'efface */
  function typewriter(root) {
    root.querySelectorAll('[data-dk-type]:not([data-dk-bound])').forEach(function (el) {
      el.setAttribute('data-dk-bound', '');
      var chars = el.querySelectorAll('.dk-char');
      if (!chars.length) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      var speed = parseInt(el.getAttribute('data-dk-type'), 10) || 42;
      el.classList.add('is-typing');
      var i = 0;
      var step = function () {
        if (i > 0) chars[i - 1].classList.remove('is-cursor');
        if (i >= chars.length) {
          el.classList.remove('is-typing');
          return;
        }
        chars[i].classList.add('is-typed', 'is-cursor');
        i += 1;
        setTimeout(step, chars[i - 1] && chars[i - 1].textContent === ' ' ? speed / 2 : speed);
      };
      setTimeout(step, 220);
    });
  }

  /* pellicule : flèches précédent / suivant, défilement par carte */
  function strip(root) {
    root.querySelectorAll('[data-dk-strip]:not([data-dk-bound])').forEach(function (track) {
      track.setAttribute('data-dk-bound', '');
      var wrap = track.closest('[data-dk-strip-scope]') || document;
      var prev = wrap.querySelector('[data-dk-strip-prev]');
      var next = wrap.querySelector('[data-dk-strip-next]');
      if (!prev || !next) return;

      var step = function () {
        var card = track.querySelector('.dk-card');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 14;
        return card ? card.getBoundingClientRect().width + gap : track.clientWidth * 0.8;
      };

      var sync = function () {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      };

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    });
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    document.querySelectorAll('.dk').forEach(function (el) {
      el.classList.add('dk--armed');
    });
    reveal(scope);
    anchors(scope);
    counters(scope);
    parallax(scope);
    strip(scope);
    typewriter(scope);
    cursorTag(scope);
    halo(scope);
    magnetic(scope);
    tilt(scope);
    sticky(document.querySelector('[data-dk-sticky]'));
    chip(document.querySelector('[data-dk-chip]'));
  }

  document.addEventListener('DOMContentLoaded', function () {
    init(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target || document);
  });

  return { init: init };
})();
